import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getThousandComma } from "../../Api/ApiCommon";
import LineBtn from "../../components/Button/LineBtn";
import LineBox from "../../components/DefaultStyles/LineBox";
import Loader from "../../components/DefaultStyles/Loader";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import SpaceBetween from "../../components/DefaultStyles/SpaceBetween";
import PartyInviteFilter from "../../components/pages/Party/PartyInvite/PartyInviteFilter";
import PartyInviteRegSuccessModal from "../../components/pages/Party/PartyInvite/PartyInviteRegSuccessModal";
import Pagination from "../../components/Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../components/Table/Table";
import { useApi } from "../../hooks/useApi";
import { secodaryMailConverter } from "../../scCommon/scCommonFunc";
import { TotalCount } from "../Users/UserInfo";
import PartyMailModal from "../../components/pages/Party/PartyDetail/PartyDetailShareInfo/PartyMailModal";
import DotStatus from "../../components/DefaultStyles/DotStatus";
import LinkidMailTab, {
  partyInviteTabState,
} from "../../components/pages/Party/PartyInvite/PartyInviteTab";
import { atom, useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { chatTabState } from "../../components/pages/Party/ChatInfo/ChatTab";
import { recentChatBtnClick } from "../../components/pages/Party/ChatInfo/ChatSearch/ChatSearchResult";
import { getSubsNameBySubsId3 } from "../../AdminApi/3.0_utils";
import { GetSubscriptionSetData_V3 } from "../../ApiTS/ServiceDatasTS_V3";
import { macroStateOptionList } from "../../components/pages/Party/PartyDetail/MacroStateChangeModal/macrostate";

interface IPartyInvite {
  diff: number;
  joindate: string;
  jointime: string;
  name: string;
  needreg: number;
  nickname: string;
  partyid: number;
  servsubsid: number;
  uid: number;
  shareinfoUpdate?: string;
  shareid: string;
  ownerid?: number;
  pindex?: number;
  linkidemail: string;
  macro: number;
}

export const partyInvitePageState = atom<number>({
  key: "partyInvitePageState",
  default: 0,
});

export default function PartyInvite() {
  const navigate = useNavigate();

  const tab = useRecoilValue(partyInviteTabState);
  const setTab = useSetRecoilState(chatTabState);
  const setRecentBtnClick = useSetRecoilState(recentChatBtnClick);
  const [savedPage, setSavedPage] = useRecoilState<number>(partyInvitePageState);

  const [page, setPage] = useState(savedPage);

  useEffect(() => {
    setSavedPage(page);
  }, [page]);
  const [searchValue, setSearchValue] = useState<string | undefined>("");
  const [filteringValue, setFilteringValue] = useState({
    regState: 2,
    macro: 0,
  });
  const [withRegOnly, setWithRegOnly] = useState(false);
  const [regSuccessModal, setRegSuccessModal] = useState(false);
  const [data, setData] = useState({
    partyId: "",
    uid: "",
  });
  const [mailModal, setMailModal] = useState(false);
  const [mailPartyData, setMailPartyData] = useState({
    member: "",
    memberEmail: "",
    party: "",
    emailRegTime: "",
  });
  const [secondaryMail, setSecondaryMail] = useState("");

  const { response, loading, fetchData } = useApi({
    method: "get",
    url:
      `party/invite?page=${page}&size=10&type=${tab}` +
      (searchValue !== "" ? `&partyid=${searchValue}` : "") +
      (filteringValue?.regState !== 100
        ? `&state=${filteringValue?.regState}`
        : ``) +
      (filteringValue?.macro > 0 ? `&macro=${filteringValue?.macro}` : ``),
  });

  const linkidMailHeader = [
    "PID",
    "Subscription",
    "파티원 UID",
    tab === 0 ? "링키드 메일" : undefined,
    tab === 1 ? "계정" : undefined,
    "최종 등록 일시",
    "등록 여부",
    tab === 2 ? "매크로 상태" : undefined,
    tab === 2 ? "바로가기" : "등록 완료 처리",
    "파티 채팅",
  ];

  return (
    <>
      <PageTitle title="파티 초대 관리" />

      <LinkidMailTab />

      <PartyInviteFilter
        setSearchValue={setSearchValue}
        filteringValue={filteringValue}
        setFilteringValue={setFilteringValue}
        setPage={setPage}
        withRegOnly={withRegOnly}
        setWithRegOnly={setWithRegOnly}
      />

      <LineBox>
        <Table tableHeadData={linkidMailHeader}>
          <>
            {response?.data?.items
              ?.filter((d: IPartyInvite) => {
                if (tab === 1 && !withRegOnly) {
                  try {
                    return JSON.parse(d?.shareid)?.shareid !== "등록필요";
                  } catch {
                    return true;
                  }
                }
                return true;
              })
              ?.map((d: IPartyInvite, index: number) => {
              const subsData = GetSubscriptionSetData_V3(d?.servsubsid);
              const isSecondary = tab === 2;

              const secondaryEmail = isSecondary
                ? secodaryMailConverter(
                    Number(d?.ownerid),
                    subsData?.SVC_ID ?? 0,
                    d?.pindex ?? 0,
                    undefined
                  )
                : "";

              const linkidMail = d?.linkidemail;
              const hasLinkidMail = Boolean(
                linkidMail && linkidMail?.length > 0
              );

              return (
                <TableBody key={index}>
                  {/* PID */}
                  <TableBodyItem
                    clickable={true}
                    onClick={() => {
                      setSavedPage(page);
                      navigate(`/party/info/${d?.partyid}`);
                    }}
                  >
                    {d?.partyid}
                  </TableBodyItem>
                  {/* Subscription */}
                  <TableBodyItem isKeepAll={true}>
                    {d?.servsubsid}_{getSubsNameBySubsId3(d?.servsubsid)}
                  </TableBodyItem>
                  {/* 파티원 UID */}
                  <TableBodyItem
                    isKeepAll={true}
                    clickable={true}
                    onClick={() => {
                      setSavedPage(page);
                      navigate(`/users/info/${d?.uid}`);
                    }}
                  >
                    {d?.uid}_{d?.name}_{d?.nickname}
                  </TableBodyItem>
                  {/* 링키드 메일 */}
                  {tab === 0 && (
                    <TableBodyItem
                      isKeepAll={true}
                      clickable={isSecondary || hasLinkidMail}
                      onClick={() => {
                        if (isSecondary) {
                          setSecondaryMail(secondaryEmail);
                        }
                        setMailPartyData({
                          emailRegTime: d?.shareinfoUpdate
                            ? dayjs(d?.shareinfoUpdate)?.format(
                                "YYYY-MM-DD HH:mm:ss"
                              )
                            : `${dayjs(d?.joindate).format("YYYY-MM-DD")} ${
                                d?.jointime ?? ""
                              }`,
                          member: `${d?.uid}_${d?.name}_${d?.nickname}`,
                          memberEmail: isSecondary
                            ? secondaryEmail
                            : linkidMail,
                          party: `${d?.partyid}_${getSubsNameBySubsId3(
                            d?.servsubsid
                          )}`,
                        });
                        setMailModal(true);
                      }}
                    >
                      {isSecondary
                        ? secondaryEmail
                        : hasLinkidMail
                        ? linkidMail
                        : "-"}
                    </TableBodyItem>
                  )}

                   {/* shareid>shareid */}
                  {tab === 1 && (
                    <TableBodyItem
                      isKeepAll={true}
                      clickable={false}
                      
                    >
                      {JSON.parse(d?.shareid)?.shareid || "-"}
                    </TableBodyItem>
                  )}
                  {/* 최종 등록 시간 */}
                  <TableBodyItem isKeepAll={true}>
                    {d?.shareinfoUpdate
                      ? dayjs(d?.shareinfoUpdate)?.format("YYYY-MM-DD HH:mm:ss")
                      : `${dayjs(d?.joindate).format("YYYY-MM-DD")} ${
                          d?.jointime ?? ""
                        }`}
                  </TableBodyItem>
                  {/* 등록 여부 */}
                  <TableBodyItem isKeepAll={true}>
                    <DotStatus
                      text={
                        d?.needreg === -1
                          ? "초대 수락 필요"
                          : d?.needreg === 0
                          ? "등록 완료"
                          : d?.diff >= 24
                          ? "24시간 경과"
                          : "등록 전"
                      }
                      color={
                        d?.needreg === 0
                          ? "#00c7c7"
                          : d?.diff >= 24 || d?.needreg === -1
                          ? "#f42d16"
                          : "#ffb100"
                      }
                      size="sm"
                    />
                  </TableBodyItem>

                  {/* 매크로 상태 */}
                  {tab === 2 && (
                    <TableBodyItem>
                      {d?.macro > 0
                        ? macroStateOptionList(true).find(
                            (p) => +p.value === d?.macro
                          )?.label
                        : "-"}
                    </TableBodyItem>
                  )}

                  {/* 등록 완료 처리 */}
                  <TableBodyItem>
                    <LineBtn
                      btnText={tab === 2 ? "바로가기" : "등록 완료"}
                      disabled={d?.needreg === 0}
                      btnClickEvent={() => {
                        if (tab === 2) {
                          setSavedPage(page);
                          navigate(`/party/info/${d?.partyid}`);
                        } else {
                          setData({
                            partyId: `${d?.partyid}_${getSubsNameBySubsId3(
                              d?.servsubsid
                            )}`,
                            uid: `${d?.uid}_${d?.name}_${d?.nickname}`,
                          });
                          setRegSuccessModal(true);
                        }
                      }}
                    />
                  </TableBodyItem>

                  <TableBodyItem>
                    <LineBtn
                      btnText="채팅 조회"
                      btnClickEvent={() => {
                        setTab(1);
                        setRecentBtnClick(true);

                        navigate({
                          pathname: `/party/chat`,
                          search: `${d?.partyid}@${d?.ownerid}@${d?.uid}`,
                        });
                      }}
                    />
                  </TableBodyItem>
                </TableBody>
              );
            })}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.totalCount : 0
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>

      {loading && <Loader />}

      {regSuccessModal && (
        <PartyInviteRegSuccessModal
          closeEvent={() => setRegSuccessModal(false)}
          confirmEvent={() =>
            fetchData({
              method: "get",
              url:
                `party/invite?page=${page}&size=10&type=${tab}` +
                (searchValue !== "" ? `&partyid=${searchValue}` : "") +
                (filteringValue?.regState !== 100
                  ? `&state=${filteringValue?.regState}`
                  : ``),
            })
          }
          data={data}
        />
      )}

      {/* 링키드 메일 모달 */}
      {mailModal && (
        <PartyMailModal
          closeEvent={() => setMailModal(false)}
          partyData={mailPartyData}
          isInviteMail={true}
          secondaryMailAcc={tab === 2 ? secondaryMail : undefined}
          type={tab === 2 ? "mailgun" : "db"}
        />
      )}
    </>
  );
}
